import api from '@services/api';

import { AccountingAccountResponse, CreateAccountingAccount } from '../models/accountingAcount';

/**
 * <p>
 * API endpoints that cover all accounting accounts related CRUD calls
 */
export const accountingAccountApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // GET
    listAccountingAccounts: builder.query<AccountingAccountResponse[], void>({
      query: () => ({
        url: encodeURI('/school/account-config/listAll'),
        method: 'GET',
      }),
      providesTags: ['AccountingAccount'],
    }),
    // POST
    createAccountingAccount: builder.mutation<AccountingAccountResponse, CreateAccountingAccount>({
      query: (input: CreateAccountingAccount) => ({
        url: encodeURI('/school/account-config/create'),
        method: 'POST',
        body: input,
      }),
      invalidatesTags: ['AccountingAccount'],
    }),
    // Update
    updateAccountingAccount: builder.mutation<AccountingAccountResponse, AccountingAccountResponse>(
      {
        query: (input: AccountingAccountResponse) => ({
          url: encodeURI('/school/account-config/update'),
          method: 'PUT',
          body: input,
        }),
        invalidatesTags: ['AccountingAccount'],
      },
    ),
    // Delete
    deleteAccountingAccount: builder.mutation<void, number>({
      query: (id: number) => ({
        url: `/school/account-config/delete?id=${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['AccountingAccount'],
    }),
  }),
});

export const {
  useListAccountingAccountsQuery,
  useCreateAccountingAccountMutation,
  useUpdateAccountingAccountMutation,
  useDeleteAccountingAccountMutation,
} = accountingAccountApi;
